import React from 'react';
import { Col, DatePicker, Form, Input, Row, Select } from 'antd';
import InputLabel from 'components/InputLabel/index';
import dayjs from 'dayjs';
import { constantFormValues } from '../../root';
import { utcConverter } from '../LeaseUtils/helper';

const GeneralLeaseInformation = ({ screen }) => {
	const form = Form.useFormInstance();
	const LeaseEndDate = dayjs().add(1, 'month');
	// const modificationSequence = form.getFieldValue('modificationSequence');
	const handleLeaseDateChange = () => {
		const leaseStartDate = form.getFieldValue('leaseStartDate');
		if (!leaseStartDate) return;
		const leaseTerm = form.getFieldValue('leaseTerm');
		if (!leaseTerm) {
			form.setFieldValue(['changes', 0, 'inputChangeEffectiveDate'], utcConverter(leaseStartDate));

			return;
		}

		const leaseEndDate = leaseStartDate.add(leaseTerm, 'month').subtract(1, 'day');

		form.setFieldValue('leaseEndDate', utcConverter(leaseEndDate));
		form.setFieldValue('leaseStartDate', utcConverter(leaseStartDate));
		form.setFieldValue(['changes', 0, 'inputChangeEffectiveDate'], utcConverter(leaseStartDate));
	};

	return (
		<Row gutter={[16, 0]} style={{ marginTop: '16px' }}>
			<Form.Item noStyle name={constantFormValues?.version?.key} />
			<Form.Item noStyle name={constantFormValues?.paymentModalitylabel?.key} />
			<Form.Item noStyle name="tabIndex" />
			<Form.Item noStyle name="endOfFinancialYear" />

			<Col xs={4}>
				<InputLabel label={constantFormValues?.LeaseId?.label} head={true} />
			</Col>
			<Col xs={8}>
				<Form.Item name={constantFormValues?.LeaseId?.key}>
					<Input disabled placeholder="To be auto generated" style={{ height: '32px', borderRadius: '4px' }} />
				</Form.Item>
			</Col>
			<Col xs={4}>
				<InputLabel label={constantFormValues?.leaseStartDate?.label} head={true} />
			</Col>
			<Col xs={8}>
				<Form.Item
					name={constantFormValues?.leaseStartDate?.key}
					rules={constantFormValues?.leaseStartDate?.rules}
					getValueFromEvent={(e) => {
						const value = e;
						const currentChanges = form.getFieldValue('changes');
						if (screen.toLowerCase() === 'create') {
							form.setFieldValue(['changes', 0, 'inputChangeEffectiveDate'], value);
						} else if (screen.toLowerCase() === 'revise') {
							form.setFieldValue(['changes', currentChanges.length - 1, 'inputChangeEffectiveDate'], value);
						}
						return value;
					}}
				>
					<DatePicker
						disabled={
							screen === 'VIEW' ||
							(screen === 'REVISE'
								? form.getFieldValue('modificationSequence') === 0
									? false
									: true
								: screen === 'CREATE'
									? false
									: true)
						}
						format="YYYY-MM-DD"
						style={{ width: '100%', height: '32px', borderRadius: '4px' }}
						onChange={handleLeaseDateChange}
					/>
				</Form.Item>
			</Col>

			<Col xs={4}>
				<InputLabel label={constantFormValues?.leaseTitle?.label} head={true} />
			</Col>
			<Col xs={8}>
				<Form.Item name={constantFormValues?.leaseTitle?.key} rules={constantFormValues?.leaseTitle?.rules}>
					<Input disabled={screen === 'VIEW'} placeholder="Write here" style={{ height: '32px', borderRadius: '4px' }} />
				</Form.Item>
			</Col>

			<Col xs={4}>
				<InputLabel label={constantFormValues?.lessorName?.label} head={true} />
			</Col>
			<Col xs={8}>
				<Form.Item name={constantFormValues?.lessorName?.key} rules={constantFormValues?.lessorName?.rules}>
					<Input disabled={screen === 'VIEW'} placeholder="Write here" style={{ height: '32px', borderRadius: '4px' }} />
				</Form.Item>
			</Col>

			<Col xs={4}>
				<InputLabel label={constantFormValues?.leaseTerm?.label} head={true} />
			</Col>
			<Col xs={8}>
				<Form.Item name={constantFormValues?.leaseTerm?.key} rules={constantFormValues?.leaseTerm?.rules}>
					<Input
						type="number"
						disabled
						placeholder="Write here"
						style={{ height: '32px', borderRadius: '4px' }}
						onChange={handleLeaseDateChange}
					/>
				</Form.Item>
			</Col>
			<Col xs={4}>
				<InputLabel label={constantFormValues?.leaseEndDate?.label} head={true} />
			</Col>
			<Col xs={8}>
				<Form.Item name={constantFormValues?.leaseEndDate?.key} rules={constantFormValues?.leaseEndDate?.rules}>
					<DatePicker disabled value={LeaseEndDate} style={{ width: '100%', height: '32px', borderRadius: '4px' }} />
				</Form.Item>
			</Col>

			<Form.Item noStyle name={constantFormValues?.paymentModality?.key} />

			<Col xs={4}>
				<InputLabel label={constantFormValues?.leaseType?.label} head={true} />
			</Col>
			<Col xs={8}>
				<Form.Item name={constantFormValues?.leaseType?.key} rules={constantFormValues?.leaseType?.rules}>
					<Select
						disabled={screen === 'VIEW'}
						showSearch
						style={{ width: '100%', height: '32px', borderRadius: '4px' }}
						filterOption={true}
						placeholder="Select from the list"
						optionFilterProp="children"
					>
						{constantFormValues?.leaseType?.options?.map(({ key, value, label }) => (
							<Select.Option key={key} value={value}>
								{label}
							</Select.Option>
						))}
					</Select>
				</Form.Item>
			</Col>

			<Col xs={4}>
				<InputLabel label={constantFormValues?.initialDiscountRate?.label} head={true} />
			</Col>
			<Col xs={8}>
				<Form.Item
					name={constantFormValues?.initialDiscountRate?.key}
					rules={constantFormValues?.initialDiscountRate?.rules}
					getValueFromEvent={(e) => {
						const value = e.target.value;
						const currentChanges = form.getFieldValue('changes');
						if (screen.toLowerCase() === 'create') {
							form.setFieldValue(['changes', 0, 'inputChangeDiscountRate'], value);
						} else if (screen.toLowerCase() === 'revise') {
							form.setFieldValue(['changes', currentChanges.length - 1, 'inputChangeDiscountRate'], value);
						}
						return value;
					}}
				>
					<Input disabled={screen === 'VIEW'} placeholder="Write here" style={{ height: '32px', borderRadius: '4px' }} />
				</Form.Item>
			</Col>
			{screen !== 'CREATE' && (
				<>
					<Col xs={4}>
						<InputLabel label={constantFormValues?.creationDate?.label} head={true} />
					</Col>
					<Col xs={8}>
						<Form.Item name={constantFormValues?.creationDate?.key}>
							<DatePicker
								type="date"
								disabled={screen === 'VIEW' || screen === 'EDIT' || screen === 'REVISE'}
								format="YYYY-MM-DD"
								style={{ width: '100%', height: '32px', borderRadius: '4px' }}
							/>
						</Form.Item>
					</Col>
					<Col xs={4}>
						<InputLabel label={constantFormValues?.lastModifiedDate?.label} head={true} />
					</Col>
					<Col xs={8}>
						<Form.Item
							name={constantFormValues?.lastModifiedDate?.key}
							// initialValue={statusData?.lastModifiedDate ? dayjs(statusData?.lastModifiedDate) : null}
						>
							<DatePicker
								type="date"
								disabled={screen === 'VIEW' || screen === 'EDIT' || screen === 'REVISE'}
								format="YYYY-MM-DD"
								style={{ width: '100%', height: '32px', borderRadius: '4px' }}
							/>
						</Form.Item>
					</Col>
				</>
			)}
		</Row>
	);
};

export default GeneralLeaseInformation;
